/**
 * App Routing Configuration
 * - Handles all routes for HL Admin Panel
 * - Includes authentication protection
 * - Public: /login
 * - Protected: /swift-app/admin/*
 */

import { Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/layout/Layout";
import ProtectedRoute from "./components/common/ProtectedRoute";
import { Provider } from "react-redux";
import { store } from "./redux/store";

import Login from "./pages/Login/Login";
import AdminPanel from "./pages/AdminPanel/AdminPanel";
import UserManagement from "./pages/UserManagement/UserManagement";
import BlogsCommunity from "./pages/BlogsCommunity/BlogsCommunity";
import PetFinder from "./pages/PetFinder/PetFinder";
import PetPlaces from "./pages/PetPlaces/PetPlaces";
import Payments from "./pages/Payments/Payments";
import Settings from "./pages/Settings/Settings";
import UserProfile from "./pages/UserManagement/UserProfile";
import UserProfileEdit from "./pages/UserManagement/UserProfileEdit";
import Consultation from "./pages/Consultation/Consultation";
import AppointmentInfo from "./pages/Consultation/AppointmentInfo";
import AppointmentEdit from "./pages/Consultation/AppointmentEdit";
import BlogsCommunityInfo from "./pages/BlogsCommunity/BlogsCommunityInfo";
import BlogEdit from "./pages/BlogsCommunity/BlogEdit";
import PetFinderEdit from "./pages/PetFinder/PetFinderEdit";
import PetFinderInfo from "./pages/PetFinder/PetFinderInfo";
import PetPlaceForm from "./pages/PetPlaces/PetPlaceForm";
import PaymentInfo from "./pages/Payments/PaymentInfo";
import Services from "./pages/Services/Services";
import ServiceForm from "./pages/Services/ServiceForm";
import ServiceDetail from "./pages/Services/ServiceDetail";
import ExportPage from "./components/common/ExportPage";
import Affiliates from "./pages/Affiliates/Affiliates";

function AppRoutes() {
  return (
    <Provider store={store}>
      <Routes>
        {/* Login Route */}
        <Route path="/login" element={<Login />} />

        {/* Protected Admin Routes */}
        <Route
          path="/swift-app/admin/*"
          element={
            <ProtectedRoute>
              <Layout>
                <Routes>
                  <Route path="" element={<AdminPanel />} />
                  <Route path="adminPanel" element={<AdminPanel />} />
                  <Route path="users" element={<UserManagement />} />
                  <Route path="consultation" element={<Consultation />} />
                  <Route path="services" element={<Services />} />
                  <Route path="blogsCommunity" element={<BlogsCommunity />} />
                  <Route path="pet-finder" element={<PetFinder />} />
                  <Route path="pet-places" element={<PetPlaces />} />
                  <Route path="pet-places/add" element={<PetPlaceForm />} />
                  <Route path="payments" element={<Payments />} />
                  <Route path="affiliates" element={<Affiliates />} />
                  <Route path="settings" element={<Settings />} />
                  <Route path="profile/:type/:id" element={<UserProfile />} />
                  <Route path="profile/:type/:id/edit" element={<UserProfileEdit />} />

                  <Route path="consultation/:id" element={<AppointmentInfo />} />
                  <Route path="consultation/:id/edit" element={<AppointmentEdit />} />
                  <Route path="services/:id" element={<ServiceDetail />} />
                  <Route path="services/:id/edit" element={<ServiceForm />} />
                  <Route path="services/new" element={<ServiceForm />} />
                  <Route path="blogsCommunity/:id" element={<BlogsCommunityInfo />} />
                  <Route path="blogs/new" element={<BlogEdit />} />
                  <Route path="blogs/:id/edit" element={<BlogEdit />} />
                  <Route path="pet-finder/:id" element={<PetFinderInfo />} />
                  <Route path="pet-finder/:id/edit" element={<PetFinderEdit />} />
                  <Route path="payments/:id" element={<PaymentInfo />} />

                  {/* ✅ Export Page Route */}
                  <Route path="export" element={<ExportPage />} />
                </Routes>
              </Layout>
            </ProtectedRoute>
          }
        />

        {/* Redirect root to admin */}
        <Route path="/" element={<Navigate to="/swift-app/admin" replace />} />
      </Routes>
    </Provider>
  );
}

export default AppRoutes;
